// Who gets the tester-invite control in the settings sheet.
//
// UI gating only. `isOwner` in netlify/functions/detect.js re-checks every `admin_invite_tester`
// call against the verified JWT, so someone who sets this from a console gets a 403 rather than a
// tester. That split is why the list can live in the bundle at all.
//
// Two founders, matched two different ways, because that is what detect.js does: Lukas by user id,
// Nick by email. An id cannot be spoofed and is the better key; an email is what you have before
// someone has signed in for the first time and their id exists.
//
// It is a mirror of the server's list rather than a shared module because detect.js is CommonJS
// running on Netlify while this is bundled into the browser — the same reason `src/app.jsx` carries
// its own copy of `slugifyTag`. The consequence to remember: adding a founder here shows them the
// control and nothing more. They also need to be in detect.js's fallbacks or its `APP_OWNER_IDS` /
// `APP_OWNER_EMAILS` env vars, or the button appears for them and returns "Not authorized".
export const APP_OWNER_IDS = ["4c2716a9-a9ed-42fd-9df4-ab5a6a342f7e"]; // Lukas
export const APP_OWNER_EMAILS = ["nbateman0@gmail.com"]; // Nick

// user: `{ id, email }` — either may be missing, which is the signed-out and the mid-load case.
export function isAppOwner(user) {
  if (!user) return false;
  const id = String(user.id || "").trim().toLowerCase();
  if (id && APP_OWNER_IDS.some((owner) => owner.toLowerCase() === id)) return true;
  const email = String(user.email || "").trim().toLowerCase();
  return !!email && APP_OWNER_EMAILS.some((owner) => owner.toLowerCase() === email);
}
